require('./inc/site.js');
require('./inc/core/tooltipster.js');
require('./inc/core/jquery-ui.js');

var dateField = undefined;
var floatingSummaryPanelBreakpoint = 1023;
var summaryBox = undefined;
var summaryPanel = undefined;

$(document).ready(function(){
  $('.date-radio').on('change', function(){
    if ($(this).prop('checked')) {
      var value = $(this).val();
      if (!window.siteHelperObj.isMobileBrowser()) {
        dateField.datepicker('setDate', value);
      } else {
        dateField.val(value);
      }
    }
  });

  $('.payment-method').on('click', function(){
    if (!$(this).hasClass('selected')) {
      $('.payment-method').removeClass('selected');
      $(this).addClass('selected');
      $(this).find('input[type="radio"]').prop('checked', true).change();
    }
  });

  summaryBox = $('[data-purpose="checkout-summary-box"]');
  if (summaryBox && summaryBox.length === 1) {
    summaryPanel = $('[data-purpose="summary-panel"]');
    checkSummaryBoxPosition();

    $(document).on(PROJECT_NAMESPACE+'.user_did_scroll', function(){
      checkSummaryBoxPosition();
    });

    $(document).on(PROJECT_NAMESPACE+'.window_width_changed', function(e, newWidth){
      checkSummaryBoxState(newWidth);
    });

    $('[data-purpose="open-summary-panel-button"]').on('click', function(){
      var open = !summaryBox.hasClass('opened-summary-box');

      if (open) {
        openSummaryBox();
      } else {
        closeSummaryBox();
      }
    });

    $('[data-purpose="close-summary-box"]').on('click', function(){
      closeSummaryBox();
    });

    summaryPanel.find('[data-purpose="summary-panel-button"]').on("click", function(){
      $('.checkout-page-inner').find('[data-purpose="send-button"]').trigger('click');
    });

    $(document).on(PROJECT_NAMESPACE+'.update_summary_box_content', function(e, html){
      summaryBox.find('.summary-box-inner').html(html);
      checkSummaryBoxPosition();
    });
  }

  initDateField();

  initTooltipster();

  initDependsOnRows();
});

function checkSummaryBoxPosition() {
  if (summaryBox && summaryBox.length === 1) {
    var scrollTop = $(window).scrollTop();
    var inner = $('.checkout-page-inner');
    if (inner.length === 1) {
      if (window.innerWidth > floatingSummaryPanelBreakpoint) {
        var offset = $('body').hasClass('opened-fix-header') ? $('.main-header .fix-content').outerHeight(true) : $('.main-header').outerHeight(true);
        var top = inner.offset().top;
        if (scrollTop + offset <= top && (summaryBox.hasClass('fixed') || summaryBox.hasClass('absolute'))) {
          summaryBox.removeClass('absolute');
          summaryBox.removeClass('fixed');
        } else if ((scrollTop + offset) > top && (scrollTop + offset + summaryBox.outerHeight()) < (top + inner.outerHeight()) && !summaryBox.hasClass('fixed')) {
          summaryBox.addClass('fixed');
          summaryBox.removeClass('absolute');
        } else if ((scrollTop + offset) > top && (scrollTop + offset + summaryBox.outerHeight()) >= (top + inner.outerHeight()) && !summaryBox.hasClass('absolute')) {
          summaryBox.removeClass('fixed');
          summaryBox.addClass('absolute');
        }
      } else if (summaryPanel && summaryPanel.length > 0) {
        var bottomBorder = inner.offset().top + inner.outerHeight();
        var checkPosition = scrollTop + window.innerHeight;

        if (checkPosition >= bottomBorder && !summaryPanel.hasClass('inactive')) {
          summaryPanel.addClass('inactive');
        } else if (checkPosition < bottomBorder && summaryPanel.hasClass('inactive')) {
          summaryPanel.removeClass('inactive');
        }
      }
    }
  }
}

function checkSummaryBoxState(newWidth) {
  if (newWidth > floatingSummaryPanelBreakpoint) {
    if (summaryBox && summaryBox.length === 1 && summaryBox.hasClass('opened-summary-box')) {
        summaryBox.removeClass('opened-summary-box');
    }

    if ($('body').hasClass('scroll-disabled')) {
      $('body, html').removeClass("scroll-disabled");
    }
  } else {
    checkSummaryBoxPosition();
  }
}

function openSummaryBox() {
  summaryBox.addClass('opened-summary-box');
  $('body, html').addClass('scroll-disabled');
}

function closeSummaryBox() {
  summaryBox.removeClass('opened-summary-box');
  $('body, html').removeClass('scroll-disabled');
}

function initDateField()
{
  dateField = $('#pickUpDateField');
  if (dateField.length === 1) {
    var isMobile = window.siteHelperObj.isMobileBrowser();

    $.datepicker.setDefaults($.datepicker.regional['hu']);

    var params = {
      dateFormat:'yy-mm-dd'
    };

    if (typeof datepickerParams !== 'undefined') {
      params = $.extend({}, params, datepickerParams);
    }

    var min = dateField.data('min');
    if (isMobile) {
      dateField.attr('type', 'date');
      if (min) {
        dateField.attr('min', min);
      }
    } else {
      dateField.attr('readonly', true);
      if (min &&  typeof params.minDate === 'undefined') {
        params.minDate = min;
      }

      params.nextText = svg('arrow-left');
      params.prevText = svg('arrow-left');
      params.onSelect = function(selectedDate, inst) {
        $('.date-radio').each(function(){
          var checked = $(this).val() == selectedDate;
          $(this).prop('checked', checked);
        });
      };

      dateField.datepicker(params);
    }
  }

}

function initTooltipster()
{
  $.fn.tooltipster('setDefaults', {
    position: 'top'
  });

  var trigger = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) ? "click" : "hover";

  $('.tooltip:not(.initialized)').each(function(){
    $(this).addClass('initialized');
    $(this).tooltipster({
      contentAsHTML:true,
      trigger: trigger
    });
  });
}


function initDependsOnRows()
{
  $('.depends-on-item').each(function(){
    $(this).on('change', function(){
      var form = $(this).parents('form');
      if (form) {
        checkDependsOnRows(form);
      }
    }).change();
  });
}

function checkDependsOnRows(form)
{
  if (form && form.length > 0) {
    form.find('[data-purpose="depends-on-row"]').each(function(){
      var expectValue = $(this).data('expect-value');
      var visible = false;
      if (expectValue) {
        var fields = expectValue.split('|');
        visible = true;
        for (var i = 0; i < fields.length; i++) {
          var tmp = fields[i].split(':');

          if (tmp.length == 2) {
            var fieldName = tmp[0];
            var values = tmp[1].split(',');

            var field = form.find('[name="'+fieldName+'"]');
            var value = field && field.length > 0 ? field.val() : '';
            if (field.is(':radio')) {
              value = '';
              $.each(field, function(){
                if ($(this).prop('checked')) {
                  value = $(this).val();
                }
              });

              if (values.indexOf(value) < 0) {
                visible = false;
              }
            } else if (field.is(':checkbox')) {
              var checkedValues = [];
              field.each(function(){
                if ($(this).prop('checked')) {
                  checkedValues.push($(this).val());
                }
              });

              var union = window.siteHelperObj.unionArray(values, checkedValues);
              if (union.length === 0) {
                visible = false;
              }
            } else if (values.indexOf(value) < 0) {
              visible = false;
            }
          } else {
            visible = false;
          }

          if (!visible) {
            break;
          }
        }
      }

      if ((visible && !$(this).hasClass('active')) || (!visible && $(this).hasClass('active'))) {
        $(this).toggleClass('active');
        $(this).slideToggle();
      }
    });
  }
}
